// Constantes.
// ----------------------------------------------------------------------
export const DEFAULT_BORDER_TYPE = 'row';
export const DEFAULT_ENABLE_ROW_SELECTION = false;
export const DEFAULT_FULL_WIDTH = true;
export const DEFAULT_LOADING_MESSAGE = 'Loading...';
export const DEFAULT_MODE = 'light';
export const DEFAULT_NO_DATA_MESSAGE = 'No Data';
export const DEFAULT_SELECTED_DATA = [];
export const DEFAULT_SIZE = 's';
export const DEFAULT_ZEBRA = false;
export const DEFAULT_STICKY_HEADER = false;
export const DEFAULT_MAX_HEIGHT = 500;
//# sourceMappingURL=ControlledTable.constants.js.map